import React from 'react';
import { OneQuestionGroup } from './IFAQAllQuestionPage';
import ChevronLink from '../../components/ui/ChevronLink';

const QuestionSection: React.FC<OneQuestionGroup> = ({ name, questions }) => {
  const modifyTitle = (title: string) => {
    return title.split(/(?=\()/).map((part: string) => {
      if (part.startsWith('(') && part.endsWith(')')) {
        return (
          <span key={part} className="font-light">
            {part}
          </span>
        );
      }
      return part;
    });
  };

  return (
    <section>
      <h2 className="font-bold font-avantgarde text-[18px] leading-[27px] sm:text-[22px] sm:leading-[33px] text-blue-900 mb-6">
        {modifyTitle(name)}
      </h2>
      <div className="space-y-4">
        {questions?.map(({id, title}) => (
          <ChevronLink key={id} href={`/home/faqvraag/${id}`} title={title} />
        ))}
      </div>
    </section>
  );
};

export default QuestionSection;
